/* eslint-disable no-console */
import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { AppBar, Collapse, styled } from '@material-ui/core';
import Navbar from '../components/Navbar/Navbar';
import { StyledName, StyledText } from '../components/Utils/TextStyles';

const useStyles = makeStyles(theme => ({
  portada: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'Fecske',
  },
  appBar: {
    background: 'none',
    maxHeight: 100,
  },
  appBarWrapper: {
    width: '90%',
    margin: '0 auto',
  },
  appBarTitle: {
    flexGrow: '1',
  },
  icon: {
    color: '#000',
    fontSize: '2rem',
  },
  colorText: {
    color: '#e2e1e1',
  },
  container: {
    textAlign: 'center',
    width: '40vh',
    marginTop: '130%',
    display: 'flex',
    flexWrap: 'wrap',
    left: 0,
    justifyContent: 'space-around',
  },
  goDown: {
    color: '#e2e1e1',
    fontSize: '4rem',
  },
}));

export default function Layout() {
  const classes = useStyles();
  const [checked, setChecked] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    setChecked(true);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  return (
    <div
      className={classes.portada}
      id='header'
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + '/image/Portada-04web.jpg'
        })`,
        backgroundPosition: 'center',
        backgroundSize: width < 420 ? 'cover' : 'contain',
        backgroundRepeat: 'no-repeat',
        // width: '100vw',
        // height: '100vh',
      }}
    >
      <AppBar className={classes.appBar} elevation={0}>
        <Navbar />
      </AppBar>
      <Collapse
        in={checked}
        {...(checked ? { timeout: 2000 } : {})}
        collapsedSize={150}
      >
        <div className={classes.container}>
          <div style={{ display: 'flex' }}>
            <StyledName color='#00774f'>Brenda</StyledName>
            <StyledName color='#bb823f'>&</StyledName>
            <StyledName color='#00774f'>Uriel</StyledName>
          </div>
        </div>
      </Collapse>
    </div>
  );
}
